const bottlePrices = [
  { maxMl: 6, price: 35 },
  { maxMl: 10, price: 40 },
  { maxMl: 15, price: 45 },
  { maxMl: 20, price: 55 },
  { maxMl: 30, price: 65 },
  { maxMl: 50, price: 70 },
];

export const getBottleCountAndPrice = (ml) => {
  const requestedMl = Math.max(Number(ml) || 0, 0);
  const bottles = [];
  let totalCost = 0;

  if (requestedMl === 0) {
    return { bottles, totalCost };
  }

  const largestBottle = bottlePrices.find(
    (bottle) => bottle.maxMl === 50
  );

  const largeBottleCount = Math.floor(
    requestedMl / largestBottle.maxMl
  );

  if (largeBottleCount > 0) {
    bottles.push({
      bottleSize: largestBottle.maxMl,
      count: largeBottleCount,
      price: largestBottle.price,
    });

    totalCost += largeBottleCount * largestBottle.price;
  }

  const remainingMl =
    requestedMl - largeBottleCount * largestBottle.maxMl;

  // Об’єм повністю розміщений у пляшечках по 50 мл
  if (remainingMl === 0) {
    return { bottles, totalCost };
  }

  // Знаходимо одну найменшу пляшечку, в яку поміститься залишок
  const remainderBottle = [...bottlePrices]
    .sort((a, b) => a.maxMl - b.maxMl)
    .find((bottle) => remainingMl <= bottle.maxMl);

  if (!remainderBottle) {
    return { bottles, totalCost };
  }

  bottles.push({
    bottleSize: remainderBottle.maxMl,
    count: 1,
    price: remainderBottle.price,
  });

  totalCost += remainderBottle.price;

  return { bottles, totalCost };
};